import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    selectBlock: {
        display: 'flex',
        justifyContent: 'space-between',
        '& div': { width: '48%' }
    }
})